<mat-card class="mat-padding">
	@if (height == 2) {

		<ngx-skeleton-loader
			animation="pulse"
			style="width: 60%"></ngx-skeleton-loader>
		<ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
	}

	@if (height == 5) {

		<ngx-skeleton-loader
			animation="pulse"
			style="width: 60%"></ngx-skeleton-loader>
		<ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 88%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 70%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			
			style="width: 56%"></ngx-skeleton-loader>
	
}
	@if (height == 12) {

		<ngx-skeleton-loader
			animation="pulse"
			style="width: 60%"></ngx-skeleton-loader>
		<ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 88%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 70%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 60%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 64%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 91%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 56%"></ngx-skeleton-loader>
		<ngx-skeleton-loader animation="pulse"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 88%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 70%"></ngx-skeleton-loader>
		<ngx-skeleton-loader
			animation="pulse"
			style="width: 60%"></ngx-skeleton-loader>
	
}
</mat-card>
